import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { DatePickerModule } from 'primeng/datepicker';
import { CalendarComponent } from '../../components';

@Component({
  selector: 'lib-type-calendar',
  imports: [
    DatePickerModule,
    CalendarComponent,
    ReactiveFormsModule,
    FormlyModule,
  ],
  template: `
    <lib-calendar
      [formControl]="formControl"
      [formlyAttributes]="field"
      [label]="to.label"
      [placeholder]="to.placeholder"
    ></lib-calendar>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TypeCalendar extends FieldType<FieldTypeConfig> {}
